const graphqlCacheConfig = {
  typePolicies: {
    PriceReport: {
      fields: {
        credit: {
          merge: true,
        },
      },
    },
    Station: {
      fields: {
        address: {
          merge: true,
        },
        prices: {
          merge: false,
        },
      },
    },
  },
};

export default graphqlCacheConfig;
